import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

//const reducer = combineReducers({})
const middleware = [thunk]
const store = createStore(composeWithDevTools(applyMiddleware(...middleware)))

export default store
